import React from "react";
import { Link } from "react-router-dom";
import { content } from "../../../data";
import StyledMdText from "../../../common/components/styledMdText/StyledMdText";
import MarketplaceStatus from "../../../components/Marketplace/MarketplaceStatus";
import StyledH1Heading from "../../../common/components/styledH1Heading/StyledH1Heading";
import StyledH6Heading from "../../../common/components/styledH6Heading/StyledH6Heading";
import HeroSectionCarousel from "../../../components/Carousel/HeroSectionCarousel/HeroSectionCarousel";


const styles = {
  backgroundSize: "auto",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "-42px -55px",
  backgroundImage:
    "url('/assets/hero-chain.svg'), url('/assets/hero-shadow.svg')",
};

const LandingSection = ({data}) => {
  return (
    <div
      style={styles}
      className="w-full -mt-[90px] flex flex-col gap-16 items-center lg:items-end"
    >
      <div className="w-[90%] sm:w-[85%] md:w-[80%] lg:w-[90%] mt-32 flex flex-col lg:flex-row gap-16 lg:gap-10 xl:gap-20 overflow-hidden">
        <div className="LeftSideContainer w-full lg:min-w-[35%] xl:min-w-[30%] yellow-border px-8 pt-8 sm:pt-12 pb-10 flex flex-col gap-10 lg:gap-16">
           <div className="pr-16">
           <StyledH1Heading fontColor={"textGradient"}>
              NFT’s Made In Gold
            </StyledH1Heading>
           
            <StyledMdText>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry
            </StyledMdText>
            </div>
          <div className="space-y-3">
            <StyledH6Heading>Join for future drops</StyledH6Heading>
            <div className="flex gap-4 xl:gap-8 items-center">
              {content.socialIcons.map((items, index) => (
                <Link
                  className="group hover:-translate-y-[3px] duration-200"
                  key={index}
                  to={items.link}
                  target="_blank"
                >
                  <span className="text-yellow-500">{items.icon}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
        <div className="w-full lg:w-[90%]">
          <div className="HeroSectionCarousel">
            <HeroSectionCarousel />
          </div>
          <MarketplaceStatus custom data={data} />
        </div>
      </div>
      <div>
        <img src="/assets/stroke-line-top.svg" alt="" loading="lazy"/>
      </div>
    </div>
  );
};

export default LandingSection;
